import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Flame, Sparkles, Tag } from "lucide-react";
import ProductCard, { ProductCardSkeleton } from "../ProductCard";
import { Reveal } from "../fx/Reveal";

const TABS = [
  { id: "best", label: "Meilleures ventes", icon: Flame },
  { id: "new", label: "Nouveautés", icon: Sparkles },
  { id: "promo", label: "Promos", icon: Tag },
];

export const ProductCarousel = ({ products, loading }) => {
  const [tab, setTab] = useState("best");
  const track = useRef(null);
  const newIds = new Set([...products].slice(-6).map((p) => p.id));
  const list = tab === "best" ? [...products].sort((a, b) => b.rating - a.rating || b.reviews - a.reviews)
    : tab === "new" ? [...products].reverse()
    : products.filter((p) => p.old_price);
  const scroll = (dir) => track.current?.scrollBy({ left: dir * Math.min(track.current.clientWidth * 0.8, 900), behavior: "smooth" });

  return (
    <section className="max-w-[1440px] mx-auto px-5 mt-24" data-testid="home-carousel">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF3B3B] font-bold mb-3">Sélection KTSauto</div>
            <h2 className="speed-line font-extrabold italic uppercase tracking-tight text-slate-50 text-3xl md:text-4xl">Nos pièces du moment</h2>
          </div>
          <div className="flex gap-2 flex-wrap" data-testid="home-carousel-tabs">
            {TABS.map((t) => (
              <button key={t.id} data-testid={`home-carousel-tab-${t.id}`} onClick={() => { setTab(t.id); track.current?.scrollTo({ left: 0 }); }}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-[13px] font-extrabold italic uppercase tracking-tight transition-all active:scale-95 ${tab === t.id ? "bg-[#E01F1F] text-white shadow-md shadow-red-950/40" : "bg-[#10131A] text-slate-400 hover:text-white border border-[#1E232D]"}`}>
                <t.icon size={14} /> {t.label}
              </button>
            ))}
          </div>
        </div>
      </Reveal>
      <div className="relative group/car">
        <button data-testid="home-carousel-prev" onClick={() => scroll(-1)} aria-label="Précédent" className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-[#10131A]/90 hover:bg-[#E01F1F] text-white border border-[#222735] shadow-xl backdrop-blur-md transition-all duration-200 opacity-0 group-hover/car:opacity-100"><ChevronLeft size={20} /></button>
        <button data-testid="home-carousel-next" onClick={() => scroll(1)} aria-label="Suivant" className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-[#10131A]/90 hover:bg-[#E01F1F] text-white border border-[#222735] shadow-xl backdrop-blur-md transition-all duration-200 opacity-0 group-hover/car:opacity-100"><ChevronRight size={20} /></button>
        <div ref={track} data-testid="home-carousel-track" className="snap-row flex gap-5 overflow-x-auto pb-4 -mx-5 px-5 md:mx-0 md:px-1">
          {loading && Array.from({ length: 4 }, (_, i) => <div key={i} className="w-[260px] sm:w-[280px] shrink-0"><ProductCardSkeleton /></div>)}
          {!loading && list.map((p) => <div key={p.id} className="w-[260px] sm:w-[280px] shrink-0"><ProductCard product={p} isNew={tab === "new" && newIds.has(p.id)} /></div>)}
          {!loading && list.length === 0 && <div className="w-full text-center text-slate-500 py-12">Aucune pièce dans cette sélection pour le moment.</div>}
        </div>
      </div>
      <div className="text-center mt-2">
        <Link to="/recherche?q=" data-testid="home-carousel-all" className="inline-flex items-center gap-1 text-slate-300 font-semibold hover:text-[#FF3B3B] transition-colors">Voir tout le catalogue <ChevronRight size={18} /></Link>
      </div>
    </section>
  );
};

export default ProductCarousel;
